export const arrayShallowEqual = (a = [], b = []) => {
  if (a.length !== b.length) return false;
  return a.every((x, i) => x === b[i]);
};
